import axios from "@axios";

export default {
  namespaced: true,
  state: {
    items: [],
    current: null,
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getCurrent(state) {
      return state.current;
    },
  },
  mutations: {
    setData(state, value) {
      state.items = Array.isArray(value) ? value : [];
    },
    setCurrent(state, value) {
      state.current = value || null;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get("v1/user_assigned_video_tours", { params });

      if (!data) return [];

      commit("setData", Array.isArray(data?.data) ? data.data : []);
      return data;
    },

    async getCurrent({ commit }, params) {
      const { data } = await axios.get("v1/user_assigned_video_tours/current", { params });
      commit("setCurrent", data?.data || null);
      return data;
    },

    async add(_, params) {
      const { data } = await axios.post("v1/user_assigned_video_tours", params);
      return data;
    },

    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/user_assigned_video_tours/${id}`, params);
      return data;
    },

    async delete(_, id) {
      const { data } = await axios.delete(`v1/user_assigned_video_tours/${id}`);
      return data;
    },

    async changeNow({ commit }, params) {
      const { data } = await axios.post("v1/user_assigned_video_tours/change-now", params);
      commit("setCurrent", data?.data || null);
      return data;
    },

    async closeCurrentOverride({ commit }, params) {
      const { data } = await axios.post("v1/user_assigned_video_tours/close-current-override", params);
      commit("setCurrent", data?.data || null);
      return data;
    },

    clear({ commit }) {
      commit("setData", []);
      commit("setCurrent", null);
    },
  },
};
